import _ from 'lodash';
import { createSelector } from 'reselect';

export const organizationSelector = state => state.organization;

export const isFinishedOnBoardingSelector = createSelector(
  [organizationSelector],
  organization => !!_.get(organization, 'finish_on_boarded_at', false)
);

export const getLastOnPremisesHeartbeatSelector = createSelector(
  [organizationSelector],
  organization => {
    let result = null;
    const lastHeartbeat = _.get(organization, 'extra.opa_last_heartbeat', null);
    // We need to check if the last heartbeat was more than 6 hours ago
    if (lastHeartbeat !== null && lastHeartbeat !== '') {
      const inputTime = new Date(lastHeartbeat * 1000);
      if (getTimeDifferenceInHours(inputTime) > 6) {
        // More than 6 hours have passed since the last heartbeat
        result = formatDate(inputTime);
      }
    }
    return result;
  }
);

function formatDate(date) {
  // Function to add leading zeros to single-digit numbers
  const addLeadingZero = number => {
    return number < 10 ? '0' + number : number;
  };

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  // Get the month, day, year, hours, and minutes
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = addLeadingZero(date.getMinutes());
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Convert hours to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12;

  // Create the string representation
  const dateString = `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;

  return dateString;
}

const getTimeDifferenceInHours = inputTime => {
  const currentTime = new Date();
  currentTime.setUTCHours(
    currentTime.getUTCHours(),
    currentTime.getUTCMinutes(),
    currentTime.getUTCSeconds(),
    0
  );

  const timeDifference = currentTime - inputTime;
  // Getting the diff hours
  return timeDifference / (1000 * 60 * 60);
};
